import { Component, OnInit } from '@angular/core';
import { ReservationsService } from 'src/app/services/reservations.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';

import { NotifierService } from 'angular-notifier';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { GreetRequestDialogComponent } from '../greet-request-dialog/greet-request-dialog.component';
import { EmployeeService } from 'src/app/services/employee.service';
import { AssignConfirmOverlapComponent } from '../greets/assign-confirm-overlap/assign-confirm-overlap.component';
import { NotificationService } from 'src/app/services/notification.service';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  agentGreetRequests;
  searchText;
  agentGreetResponse;
  searchResponseText;
  stationsList = [];
  bsModalRef?: BsModalRef;
  constructor(private reservationsService: ReservationsService,
    private notifier: NotifierService,
    private authService: AuthenticationService,
    private modalService: BsModalService,
    private employeeService: EmployeeService,
    private notificationService: NotificationService,
    private spinner: NgxSpinnerService,) {
  }

  ngOnInit() {
    this.spinner.show();
    if (this.authService.isStationAdmin()) {
      this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
        this.stationsList = [];
        res['result']['stations'].forEach(station => {
          this.stationsList.push(station.stationid);
        });

        let data = {
          "stations": this.stationsList
        }
        this.reservationsService.getAgentsGreetRequestsOfStationManager(data).subscribe(res => {
          this.agentGreetRequests = res['result'];
          this.agentGreetRequests.sort((a, b) => new Date(a.DATE_TIME).getTime() - new Date(b.DATE_TIME).getTime());
          this.updateNotificationToSeen();
          this.spinner.hide();
        });
      });


      this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
        this.stationsList = [];
        res['result']['stations'].forEach(station => {
          this.stationsList.push(station.stationid);
        });

        let data = {
          "stations": this.stationsList
        }
        // console.log(data);
        this.reservationsService.getAgentsGreetResponsesOfStationManager(data).subscribe(res => {
          this.agentGreetResponse = res['result'];
          // this.agentGreetResponse.sort((a, b) => new Date(a.DATE_TIME).getTime() - new Date(b.DATE_TIME).getTime());
          this.spinner.hide();
        });
      });

    } else {
      //superAdmin
      this.reservationsService.getAgentsGreetRequests().subscribe(res => {
        this.spinner.hide();
        this.agentGreetRequests = res['result'];
        if (this.agentGreetRequests)
          this.agentGreetRequests.sort((a, b) => new Date(a.DATE_TIME).getTime() - new Date(b.DATE_TIME).getTime());
         this.updateNotificationToSeen();
      });
     
      this.reservationsService.getAgentsGreetResponse().subscribe(res => {
        this.agentGreetResponse = res['result'];
        this.spinner.hide()
      }); 

    }

  }

  refreshData() {
    this.getAgentGreetRequest();
    this.getAgentGreetResponse();
  }
  async getAgentGreetRequest() {
    this.spinner.show();
    if (this.authService.isStationAdmin()) {
      this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
        this.stationsList = [];
        res['result']['stations'].forEach(station => {
          this.stationsList.push(station.stationid);
        });

        let data = {
          "stations": this.stationsList
        }
        this.reservationsService.getAgentsGreetRequestsOfStationManager(data).subscribe(res => {
          this.agentGreetRequests = res['result'];
          this.agentGreetRequests.sort((a, b) => new Date(a.DATE_TIME).getTime() - new Date(b.DATE_TIME).getTime());
          this.spinner.hide();
          this.updateNotificationToSeen();
        });
      });


    } else {
      //superAdmin
      this.reservationsService.getAgentsGreetRequests().subscribe(res => {
        this.spinner.hide();
        this.agentGreetRequests = res['result'];
        if (this.agentGreetRequests)
          this.agentGreetRequests.sort((a, b) => new Date(a.DATE_TIME).getTime() - new Date(b.DATE_TIME).getTime());
          this.updateNotificationToSeen();
      });
      this.ngOnInit();
    }
  }
  getAgentDailyCap(userId, date) {
    let data = {
      userId: userId, date: date
    }
    this.reservationsService.getAgentDailyCap(data).subscribe(res => {
      // console.log(res['result']);
    });
  }

  getAgentGreetResponse() {
    this.spinner.show();

    if (this.authService.isStationAdmin()) {
      //StationManager

      // let stations = this.getStationsByManager().then(value => value);
      // let data = {
      //   "stations": stations
      // }
      // console.log(data);
      // this.reservationsService.getAgentsGreetResponsesOfStationManager(data).subscribe(res => {
      //   this.agentGreetRequests = res['result'];
      //   this.agentGreetRequests.sort((a, b) => new Date(a.DATE_TIME).getTime() - new Date(b.DATE_TIME).getTime());
      //   this.spinner.hide();
      // });

      this.spinner.show()
      this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
        this.stationsList = [];
        res['result']['stations'].forEach(station => {
          this.stationsList.push(station.stationid);
        });

        let data = {
          "stations": this.stationsList
        }
        // console.log(data);
        this.reservationsService.getAgentsGreetResponsesOfStationManager(data).subscribe(res => {
          this.agentGreetResponse = res['result'];
          // this.agentGreetResponse.sort((a, b) => new Date(a.DATE_TIME).getTime() - new Date(b.DATE_TIME).getTime());
          this.spinner.hide();
        });
      });



    } else {
      this.reservationsService.getAgentsGreetResponse().subscribe(res => {
        this.agentGreetResponse = res['result'];
        this.spinner.hide()
      });
    }
  }

  assignGreet(greet) {
    this.spinner.show();
    let data = {
      resId: greet.RESID,
      startTime: greet.STARTDT,
      endTime: greet.ENDDT,
      userId: greet.USER_ID,
      ASSIGNED_BY:this.authService.getCurrentUserId(),
      action_by: this.authService.getCurrentUserId(),
      status: 'Approved',
      reason: '',
      action_time: moment.utc().format('YYYY-MM-DD')
    }
    //adminApproveGreetRequest
    this.reservationsService.approveAgentGreetRequest(data).subscribe(res => {
      // console.log(res['result']);
      if (res['status']) {
        this.notifier.notify('success', 'Successfully Assigned..');
        this.reservationsService.updateGreetRequest(data).subscribe(res => {
          // console.log(res['result']);
          this.ngOnInit();
        });
      } else if (res['message'] == 'OVERLAPPED_TIME') {

        const initialState = {
          dialogData: data,
        };
        const modalRef = this.modalService.show(AssignConfirmOverlapComponent, { initialState });
        // modalRef.setClass('modal-lg');
        modalRef.content.event.subscribe(res => {
          if (res.data) {
            this.notifier.notify('success', 'Successfully Assigned..');
            this.reservationsService.updateGreetRequest(data).subscribe(res => {
              // console.log(res['result']);
              this.ngOnInit();
            });
          } else {
            modalRef.hide()
          }
        });
      }

      else {
        this.notifier.notify('warning', res['message']);
        data.status = 'Failed';
        data.reason = res['message'];
        this.reservationsService.updateGreetRequest(data).subscribe(res => {
          // console.log(res['result']);
          this.ngOnInit();
        });
      }
      this.spinner.hide();
      this.getAgentGreetRequest();
    });
  }

  rejectGreet(greet) {
    let data = {
      resId: greet.RESID,
      startTime: greet.STARTDT,
      endTime: greet.ENDDT,
      userId: greet.USER_ID,
      action_by: this.authService.getCurrentUserId(),
      status: 'Rejected',
      reason: '',
      agent: greet.AGENT,
      action_time: moment.utc().format('YYYY-MM-DD')
    }
    const initialState = {
      greetInfo: data,
    };
    this.bsModalRef = this.modalService.show(GreetRequestDialogComponent, { initialState });
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.event.subscribe(res => {
      if (res.data) {
        this.getAgentGreetRequest();
        this.getAgentGreetResponse();
      } else {
        this.bsModalRef.hide()
      }
    });
  }

  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

  tabCardResponseClick() {
    this.searchResponseText = '';
    this.getAgentGreetResponse();
  }

  tabCardRequestClick() {
    this.searchText = '';
    this.getAgentGreetRequest();
  }


  async getStationsByManager() {
    this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
      res['result']['stations'].forEach(station => {
        this.stationsList.push(station.stationid);
      });
    });
    return this.stationsList;
  }


  updateNotificationToSeen() {
    // console.log('Notification Component: updating notification number');
    this.notificationService.updateNotifications(this.getAgentGreetRequest.length); 
  }


}
